import ViewLayoutSection_vue_vue_type_script_setup_true_lang_default from "./ViewLayoutSection.vue.script.js";
//#region src/components/ViewLayout/ViewLayoutSection.vue
var ViewLayoutSection_default = ViewLayoutSection_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ViewLayoutSection_default as default };

//# sourceMappingURL=ViewLayoutSection.vue.js.map